import { Button } from "@light-technology/components";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useEffect, useRef } from "react";
import { Navigate, useSearchParams } from "react-router";
import { api } from "../../state/api";
import { useDocumentTitle } from "../../utilities/useDocumentTitle";
import { AcceptInviteCreate } from "./AcceptInviteCreate";

export const AcceptInvitePage = () => {
  useDocumentTitle("Accept invite");

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const hasCalledInvite = useRef(false);

  const [acceptInvite, acceptInviteResult] = api.useAcceptInviteMutation();
  // Only fetch user if the accept invite succeeded with a 200 (user was already logged in)
  // If it returned 202, user needs to sign up/login first
  const shouldFetchUser =
    acceptInviteResult.isSuccess && acceptInviteResult.data;
  const getUser = api.useGetUserQuery(shouldFetchUser ? null : skipToken);

  useEffect(() => {
    if (token && !hasCalledInvite.current) {
      hasCalledInvite.current = true;
      acceptInvite({ invite_token: token });
    }
  }, [token, acceptInvite]);

  if (!token) {
    return <Navigate to="/" />;
  }

  if (acceptInviteResult.isError) {
    return (
      <div className="flex size-full flex-col justify-center text-center">
        <div className="mb-2xl text-lg font-semibold">Invalid token</div>
        <div className="mb-3xl text-tertiary">
          This invite token is not valid. Either it was already used or is
          expired. Please ask for another one.
        </div>
        {getUser.data ? (
          <Button href="/" className="w-full" size="lg">
            Continue to your account
          </Button>
        ) : (
          <Button href="/" className="w-full" size="lg">
            Continue to login
          </Button>
        )}
      </div>
    );
  }

  if (acceptInviteResult.isSuccess) {
    return getUser.data ? (
      <Navigate to="/" />
    ) : (
      <AcceptInviteCreate token={token} />
    );
  }

  return null;
};
